import React, {useEffect, useState} from "react";
import _ from "lodash";
import {
    PRINTFUL_PRODUCTS_PRICE_FIELDS_LIST, PRINTFUL_PRODUCTS_PRICE_INPUT_FIELD_GROUPS,
    PRINTFUL_PRODUCTS_PRICE_INPUT_FIELDS
} from "../../constants/printful-products-price.constant";
import {updateSinglePrintfulProductsPrice} from "../../services/printful-products-price-data.service";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import {XMarkIcon} from "@heroicons/react/24/solid";
import RenderFields from "../../../common/ui/render-fields";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {
    calculateProductPrice,
    prepareExistingProduct,
    prepareVariantsPriceRange
} from "../../utils/printful-price-util";

const EditPrintfulProductsPrice = ({
                                       selectedPrintfulProductsPrice = {},
                                       refreshPrintfulProductsPriceList,
                                       isEditPrintfulProductsPrice = false,
                                       existingProduct,
                                       afterChanges = undefined
                                   }) => {
    const [showModal, setShowModal] = useState(false);
    const [printfulProductsPrice, setPrintfulProductsPrice] = useState(null);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [printfulProductsPriceFieldInputs, setPrintfulProductsPriceFieldInputs] = useState(PRINTFUL_PRODUCTS_PRICE_INPUT_FIELDS);

    useEffect(() => {

        if (showModal) {
            if (isEditPrintfulProductsPrice) {
                setPrintfulProductsPrice(selectedPrintfulProductsPrice);
            }
        }

    }, [showModal]);

    const handleConfirmAction = async () => {
        setSaveInProgress(true);

        const existingPrintfulProductsPrice = {...printfulProductsPrice};

        if (isEditPrintfulProductsPrice) {
            await updateSinglePrintfulProductsPrice(existingPrintfulProductsPrice);
        }

        setSaveInProgress(false);

        if (afterChanges) {
            existingProduct = prepareExistingProduct(existingPrintfulProductsPrice, existingProduct);
            afterChanges(existingPrintfulProductsPrice, existingProduct);
        } else {
            refreshPrintfulProductsPriceList();
        }

        setShowModal(false);
    }

    const handlePrintfulProductsPriceChanges = (event) => {
        let existingPrintfulProductsPrice: any = {...printfulProductsPrice};
        existingPrintfulProductsPrice = handleFieldValueChanges(event, existingPrintfulProductsPrice);

        _.forEach(existingPrintfulProductsPrice.variants, (variant) => {
            calculateProductPrice(variant, existingPrintfulProductsPrice);
        });

        prepareVariantsPriceRange(existingPrintfulProductsPrice.variants, existingPrintfulProductsPrice, existingProduct);

        setPrintfulProductsPrice(existingPrintfulProductsPrice);
    }

    const handleCloseAction = () => {
        setShowModal(false);
    }

    return (
        <>
            {isEditPrintfulProductsPrice &&
                <button
                    className="button-green-outline px-3 py-1"
                    onClick={() => setShowModal(true)}>
                    Edit
                </button>
            }

            {showModal && printfulProductsPrice ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-1/2 my-6 mx-auto">
                            {/*content*/}
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-gray-100 outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex items-start justify-between p-5 border-b border-solid rounded-t">
                                    <h3 className="text-lg font-semibold">
                                        <div>Edit Printful Products Price</div>

                                        <div className={'mt-1 flex justify-start items-center'}>
                                            <div
                                                className={'text-purple-600 font-semibold'}>{printfulProductsPrice?.title}</div>
                                            <span className={'mx-2'}>|</span>
                                            <div
                                                className={'text-gray-600 font-semibold'}>{printfulProductsPrice?.product_type}</div>
                                            <span className={'mx-2'}>|</span>
                                            <div
                                                className={'text-blue-600 font-semibold'}>{printfulProductsPrice?.category}</div>
                                        </div>
                                    </h3>

                                    <div className="">
                                        <button
                                            className="button-gray-outline px-1 py-1"
                                            onClick={handleCloseAction}>
                                            <div className="">
                                                <XMarkIcon className="h-6 w-6"/>
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                {/*body*/}
                                <div className="relative p-5 flex-auto">
                                    <div className="leading-relaxed">
                                        {PRINTFUL_PRODUCTS_PRICE_INPUT_FIELD_GROUPS?.map((fieldGroup, fieldGroupIndex) => (

                                            <div key={fieldGroupIndex} className="flex flex-wrap justify-start">
                                                <RenderFields
                                                    parentForm={printfulProductsPrice}
                                                    handleDetailChanges={handlePrintfulProductsPriceChanges}
                                                    fieldList={_.groupBy(printfulProductsPriceFieldInputs, 'group')[fieldGroup?.attribute]}
                                                    enableEdit={fieldGroup?.editable}/>
                                            </div>

                                        ))}
                                    </div>
                                </div>
                                {/*footer*/}
                                <div
                                    className="flex items-center justify-end p-5 border-t border-solid border-blueGray-200 rounded-b">
                                    <div className="ml-4 -mt-1">
                                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                                    </div>
                                    <button
                                        className="ml-2 text-gray-500 font-bold border border-gray-500 h-8 rounded px-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="ml-2 bg-green-500 text-white active:bg-green-600 h-8 rounded px-4 shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleConfirmAction}>
                                        Confirm Printful Products Price
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </>
    );
}

export default EditPrintfulProductsPrice;
